module.exports = __webpack_public_path__ + "9c7fa9813ee7b46e7e8e44e0a41af948.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/logo/ttround.png
// module id = 155
// module chunks = 0